export default __webpack_public_path__ + "static/hero_about_me_2.jpg-f451a2975046bc0e4b9624d4253f2d74.jpeg";